import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CreateFileDropdown } from "@/04-features/create-file-dropdown";
import { useState, useRef } from "react";
import styles from "./index.module.css";
export const CreateFileButton = ({ parentId = null, onProcessFinished = () => { }, }) => {
    const [isShown, setShown] = useState(false);
    const buttonRef = useRef(null);
    return (_jsxs("div", Object.assign({ className: styles.container }, { children: [_jsx("button", Object.assign({ ref: buttonRef, className: styles.button, type: "button", onClick: () => setShown(true) }, { children: "[+]" })), _jsx(CreateFileDropdown, { isShown: isShown, setShown: setShown, buttonRef: buttonRef, parentId: parentId, onProcessFinished: onProcessFinished })] })));
};
